



















































import Vue from 'vue';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import { requestUpdateYourProfile } from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import votingPdfMaker from '@/helpers/pdfmakers/voting';
import transferPdfMaker from '@/helpers/pdfmakers/transfer';
import orderPdfMaker from '@/helpers/pdfmakers/order';
import certificatePdfMaker from '@/helpers/pdfmakers/certificate';
import approveNewMemberPdfMaker from '@/helpers/pdfmakers/approveNewMember';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;
const CERTIFICATE_DATE = formatData.certificateDate;
const STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RESOLVED: 'RESOLVED',
  RECEIVED: 'RECEIVED',
  SENT: 'SENT'
};

@Component({
  name: 'ProfilePage',
  components: {
    SidebarRight,
    tableComponent,
    titlePageComponent,
    PulseLoader
  }
})
export default class ProfilePage extends Base {
  btnText = 'Update profile';
  actionsTable = {
    titleText: 'PAST ACTION',
    titleBg: 'green-title',
    sorted: 'counter',
    trackBy: 'counter',
    columns: [
      { field: 'counter', title: '#' },
      { field: 'type', title: 'ACTION' },
      { field: 'date', title: 'DATE' },
      { field: 'position', title: 'POSITION' },
      { field: 'amount', title: 'AMOUNT' },
      { field: 'outcome', title: 'OUTCOME' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };

  // Computed
  get isUpdateMemberPending() {
    return this.getPendings.member.update;
  }
  get actionsData() {
    const rows: any[] = [];
    if (!this.getMember()) return;
    const addr = this.getMember().address;
    const position = this.getMember().position;

    //Voting
    for (let variable in this.getVotings) {
      let row: any = {};
      let voting = this.getVotings[variable];
      let vote = this.getVotes[variable];
      if (!voting.resolvedTime) continue;
      if (voting.creator !== addr || voting.resolvedAddr !== addr) continue;
      row.type = 'Vote';
      row.date = this.$moment.unix(voting.resolvedTime).format(FORMAT_DATE);
      row.position = position;
      row.amount = vote ? formatData.number(Math.abs(vote.voterBalance)) : 'Not voted';
      row.outcome = voting.passed ? STATUS.APPROVED : STATUS.REJECTED;
      row.action = this.downloadVoting;
      row.styleClass = voting.passed > 0 ? 'approved' : 'denied';
      row.id = voting.id;
      row.timestamp = voting.resolvedTime;
      rows.push(row);
      if (voting.resolvedAddr === addr) {
        let resolveRow: any = {};
        resolveRow.type = 'Resolve voting';
        resolveRow.date = row.date;
        resolveRow.position = row.position;
        resolveRow.amount = '';
        resolveRow.outcome = STATUS.RESOLVED;
        resolveRow.styleClass = 'approved';
        resolveRow.action = this.downloadVoting;
        resolveRow.id = voting.id;
        resolveRow.timestamp = voting.resolvedTime;
        rows.push(resolveRow);
      }
    }
    //Approve New Member
    for (let variable in this.getMembers) {
      let row: any = {};
      let member = this.getMembers[variable];
      if (member.approver !== addr) continue;
      row.type = 'Approve new member';
      row.date = this.$moment.unix(member.creationTime).format(FORMAT_DATE);
      row.position = position;
      row.amount = '';
      row.outcome = STATUS.APPROVED;
      row.styleClass = 'approved';
      row.action = this.downloadApproveMember;
      row.id = member.address;
      row.timestamp = member.creationTime;
      rows.push(row);
    }

    // Trades
    for (const variable in this.getTrades) {
      let outcome;
      let styleClass;
      const trade = this.getTrades[variable];
      const row: any = {};
      const tradeData = this.getTradeData(trade, this.getOrders);
      if (
        !tradeData ||
        (tradeData.creator !== this.getWallet && tradeData.order.address !== this.getWallet)
      )
        continue;
      const isOrderCreator = tradeData.order.address === this.getWallet;
      if (tradeData.mode === 1 && tradeData.creator === this.getWallet) {
        outcome = 'SELL';
        styleClass = 'denied';
      } else if (tradeData.mode === 1 && isOrderCreator) {
        outcome = 'BUY';
        styleClass = 'approved';
      } else if (tradeData.mode === 2 && isOrderCreator) {
        outcome = 'SELL';
        styleClass = 'denied';
      } else if (tradeData.mode === 2 && tradeData.creator === this.getWallet) {
        outcome = 'BUY';
        styleClass = 'approved';
      }

      row.type = 'Trade';
      row.date = this.$moment.unix(tradeData.startTime).format(FORMAT_DATE);
      row.position = position;
      row.amount = tradeData.amount;
      row.outcome = outcome;
      row.styleClass = styleClass;
      row.action = this.downloadTrade;
      row.id = tradeData.id;
      row.timestamp = tradeData.startTime;
      rows.push(row);
    }

    //Transfer
    for (let variable in this.getTokenTransfers) {
      let row: any = {};
      let transfer = this.getTokenTransfers[variable];
      let from = transfer.from;
      let to = transfer.to;
      if (
        (from !== addr && to !== addr) ||
        rows.some(row => row.type === 'Trade' && row.timestamp === transfer.date)
      )
        continue;
      row.type = 'Transfer';
      row.date = this.$moment.unix(transfer.date).format(FORMAT_DATE);
      row.position = position;
      row.amount = formatData.number(transfer.value);
      row.outcome = from === addr ? STATUS.SENT : STATUS.RECEIVED;
      row.action = this.downloadTransfer;
      row.styleClass = from === addr ? 'denied' : 'approved';
      row.id = transfer.id;
      row.timestamp = transfer.date;
      rows.push(row);
    }

    const sorter = (firstEl, secondEl) => firstEl.timestamp - secondEl.timestamp;
    rows.sort(sorter).forEach((el, i) => (el.counter = i + 1));
    Vue.set(this.actionsTable, 'rows', rows);
    return this.actionsTable;
  }

  // Actions
  requestUpdateYourProfile() {
    this.setSideBarForm(requestUpdateYourProfile(this.getMember(), this.getMemberAvatar));
    this.openClose();
  }
  downloadApproveMember(addr) {
    const filename = this.getTokenInfo.symbol + '_approve_member';
    const approveDate = this.$moment.unix(this.getMember(addr).creationTime).format(FORMAT_DATE);
    approveNewMemberPdfMaker(addr, approveDate, this.getMember, this.getOwners).download(
      filename
    );
  }
  downloadVoting(id) {
    const voting = this.getVotings[id];
    const filename = this.getTokenInfo.symbol + '_voting_#' + (id + 1);
    const data = {
      resolvedTime: this.$moment.unix(voting.resolvedTime).format(FORMAT_DATE),
      passed: voting.passed,
      subject: voting.subject,
      description: voting.description
    };

    this.getVotingVotesDapp(id).then(res => {
      votingPdfMaker(data, res, this.getMember, this.getOwners).download(filename);
    });
  }
  downloadTransfer(id) {
    const transfer = this.getTokenTransfers[id];
    const filename = this.getTokenInfo.symbol + '_transfer_#' + (id + 1);
    const from = transfer.from;
    const to = transfer.to;
    const data: any = {};
    data.date = this.$moment.unix(transfer.date).format(FORMAT_DATE);
    data.from = this.getMember(from) ? this.getMember(from).name : from;
    data.to = this.getMember(to) ? this.getMember(to).name : to;
    transferPdfMaker(
      data,
      transfer,
      this.getMember,
      this.getOwners,
      this.getCompanyInfo
    ).download(filename);
  }
  downloadTrade(id, row) {
    const trade: any = this.getTradeData(this.getTradeById(id), this.getOrders);
    const filename = this.getTokenInfo.symbol + '_trade_#' + (id + 1);
    const from = trade.from;
    const to = trade.to;
    row.order = trade.order;
    row.date = this.$moment.unix(trade.startTime).format(FORMAT_DATE);
    row.from = this.getMember(from) ? this.getMember(from).name : from;
    row.to = this.getMember(to) ? this.getMember(to).name : to;
    orderPdfMaker(row, this.getMember, this.getOwners).download(filename);
  }
  downloadSharesCertificate() {
    const fileName = this.getTokenInfo.symbol + '_shares_certificate';
    const certificateData = {
      totalSupply: formatData.number(this.getTokenInfo.totalSupply),
      tokenBalance: this.getTokenBalance(),
      companyName: this.getCompanyName,
      date: this.$moment(Date.now()).format(CERTIFICATE_DATE),
      profileName: this.getMember().name
    };
    certificatePdfMaker(certificateData, this.getMember, this.getOwners).download(fileName);
  }
  getTradeData(trade, orders) {
    let from;
    let to;
    const order: any = Object.keys(orders).find(key => orders[key].id === trade.orderId);
    const tradeOrder: any = orders[order];
    if (!tradeOrder) return;
    if (tradeOrder.mode === 2) {
      from = tradeOrder.address;
      to = trade.creator;
    } else {
      from = trade.creator;
      to = tradeOrder.address;
    }
    return {
      id: trade.id,
      amount: trade.amount,
      creator: trade.creator,
      isSuccess: trade.isSuccess,
      startTime: trade.startTime,
      endTime: trade.endTime,
      mode: tradeOrder.mode,
      price: tradeOrder.price,
      from,
      to,
      order: tradeOrder
    };
  }
  getTradeById(id) {
    const tradeIndex: any = Object.keys(this.getTrades).find(key => this.getTrades[key].id === +id);
    return this.getTrades[tradeIndex];
  }
};
